module.exports = __webpack_public_path__ + "static/media/12 Step based Active.a7cd1023.svg";